export const clearServerSession = async () => {
  const result = await fetch('https://login.band.com.br/logout', {
    method: 'GET',
    credentials: 'include',
  });

  return result;
};
